import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from '@cotyorg/ccx-utils/js/components/LazyLoad';
import Picture from './Picture';

// Render is being called twice because Component is being thrown away higher up
const PictureWrapper = props => (
  // eslint-disable-next-line no-undef
  props.doNotLazyLoad || (typeof STYLEGUIDIST_ENV !== 'undefined' && STYLEGUIDIST_ENV === 'test') ? (
    <Picture {...props} doNotLazyLoad />
  ) : (
    <LazyLoad {...props} />
  )
);

PictureWrapper.propTypes = {
  doNotLazyLoad: PropTypes.bool,
  imageDecode: PropTypes.string,
  pictures: PropTypes.objectOf(PropTypes.object),
  src: PropTypes.string.isRequired,
};

export default PictureWrapper;
